
import { useState } from "react";
import {
  Box,

  Tab,
  Tabs,

} from "@mui/material";
import PatientDiagnosis from "../../../../Diagnosis";
import Problems from "../../../../Problems/Problems";
import Investigation from "../../../../Investigation/Investigation";
import DentalTable from "../../../components/DentalForm/components/DentalTable";
import UploadDocuments from "../../../../UploadDocuments";
// import { CptCodeType } from "../../../../Procedures/types"

const EmrTabs = () => {
  const [value, setValue] = useState(0);

  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <>
      <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label="Procedures" />
          <Tab label="Investigation" />
          <Tab label="Diagnosis" />
          <Tab label="Problems" />
          <Tab label="Upload Documents" />
        </Tabs>
      </Box>


      {value === 0 && <DentalTable />}
      {value === 1 && <Investigation />}
      {value === 2 && <PatientDiagnosis />}
      {value === 3 && <Problems />}
      {value === 4 && <UploadDocuments />}

    </>
  );
};

const DentalTabs = () => {
  return <EmrTabs />;
};

export default DentalTabs;

